import { Injectable, signal, computed } from '@angular/core';

/**
 * Tracks how many HTTP requests are currently in flight, app-wide.
 * The loadingInterceptor increments on request start and decrements on finish,
 * so `loading()` is true whenever anything is being fetched or saved.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly count = signal(0);

  /** true while at least one HTTP request is in flight */
  readonly loading = computed(() => this.count() > 0);

  start(): void { this.count.update(n => n + 1); }
  stop(): void  { this.count.update(n => Math.max(0, n - 1)); }
}